import axios from 'axios';

// Detectar se está em produção
const isProduction = process.env.NODE_ENV === 'production' || 
                      (window.location.hostname !== 'localhost' && 
                       window.location.hostname !== '127.0.0.1');

// URL da API: produção usa Cloudflare Workers, desenvolvimento usa localhost
const API_URL = process.env.REACT_APP_API_URL || 
  (isProduction 
    ? 'https://crm-lf-backend.josandru.workers.dev/api'
    : 'http://localhost:5000/api');

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para adicionar token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;

// Imóveis
export const getImoveis = (filters = {}) => {
  return api.get('/imoveis', { params: filters });
};

export const getImovel = (id) => {
  return api.get(`/imoveis/${id}`);
};

export const getImoveisSimilares = (id) => {
  return api.get(`/imoveis/${id}/similares`);
};

export const getImoveisDestaques = () => {
  return api.get('/imoveis/destaques');
};

export const getImoveisLancamentos = () => {
  return api.get('/imoveis/lancamentos');
};

export const createImovel = (data) => {
  return api.post('/imoveis', data);
};

export const updateImovel = (id, data) => {
  return api.put(`/imoveis/${id}`, data);
};

export const deleteImovel = (id) => {
  return api.delete(`/imoveis/${id}`);
};

export const uploadFotosImovel = (id, files) => {
  const formData = new FormData();
  files.forEach(file => {
    formData.append('fotos', file);
  });
  return api.post(`/imoveis/${id}/fotos`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const getSituacoes = () => {
  return api.get('/imoveis/situacoes/list');
};

export const getStatusConstrucao = () => {
  return api.get('/imoveis/status-construcao/list');
};

// Clientes
export const getClientes = (filters = {}) => {
  return api.get('/clientes', { params: filters });
};

export const getCliente = (id) => {
  return api.get(`/clientes/${id}`);
};

export const createCliente = (data) => {
  return api.post('/clientes', data);
};

export const updateCliente = (id, data) => {
  return api.put(`/clientes/${id}`, data);
};

export const deleteCliente = (id) => {
  return api.delete(`/clientes/${id}`);
};

// Relacionamento Cliente-Imóvel
export const adicionarImovelCliente = (clienteId, imovelId, tipoInteresse = 'interesse', observacoes = '') => {
  return api.post(`/clientes/${clienteId}/imoveis`, {
    imovel_id: imovelId,
    tipoInteresse,
    observacoes
  });
};

export const removerImovelCliente = (clienteId, imovelId) => {
  return api.delete(`/clientes/${clienteId}/imoveis/${imovelId}`);
};

export const getClientesSituacoes = () => {
  return api.get('/clientes/situacoes/list');
};

export const getTiposDocumento = () => {
  return api.get('/clientes/tipos-documento/list');
};

export const getTiposVinculo = () => {
  return api.get('/clientes/tipos-vinculo/list');
};

// Agendamentos
export const getAgendamentos = (filters = {}) => {
  return api.get('/agendamentos', { params: filters });
};

export const getAgendamento = (id) => {
  return api.get(`/agendamentos/${id}`);
};

export const createAgendamento = (data) => {
  return api.post('/agendamentos', data);
};

export const updateAgendamento = (id, data) => {
  return api.put(`/agendamentos/${id}`, data);
};

export const deleteAgendamento = (id) => {
  return api.delete(`/agendamentos/${id}`);
};

// Construtores
export const getConstrutores = () => {
  return api.get('/construtores');
};

export const getConstrutor = (id) => {
  return api.get(`/construtores/${id}`);
};

export const createConstrutor = (data) => {
  return api.post('/construtores', data);
};

export const updateConstrutor = (id, data) => {
  return api.put(`/construtores/${id}`, data);
};

export const deleteConstrutor = (id) => {
  return api.delete(`/construtores/${id}`);
};

// Dashboard
export const getDashboardStats = () => {
  return api.get('/dashboard/stats');
};

export const getDashboardRecent = () => {
  return api.get('/dashboard/recent');
};

// Tags
export const getTags = () => {
  return api.get('/tags');
};

export const createTag = (nome) => {
  return api.post('/tags', { nome });
};

// Auth
export const login = (email, senha) => {
  return api.post('/auth/login', { email, senha });
};

export const verifyToken = () => {
  return api.post('/auth/verify');
};


